<template>
  <div id="ruleVaccinationForm">
    <div class="text-h6" v-if="requirementIds && requirementIds.length > 0 && requirement">
      Requirement: {{ requirement.name }}
    </div>
    <div v-else>
          Requirement is not found
    </div>
    <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
      <div class="d-flex flex-column flex-md-row justify-space-between">
        <v-radio-group
          :disabled="requirement.used" 
          class="flex-grow-1"
          v-model="ruleVaccination.multipleDose"
          row
        >
          <template v-slot:label>
            <div>Multiple Doses</div>
          </template>
          <v-radio :value="true">
            <template v-slot:label>
              <div>Yes</div>
            </template>
          </v-radio>

          <v-radio :value="false">
            <template v-slot:label>
              <div>No</div>
            </template>
          </v-radio>
        </v-radio-group>
        <v-radio-group
          v-if="ruleVaccination.multipleDose"
          :disabled="requirement.used" 
          class="flex-grow-1"
          v-model="ruleVaccination.annually"
          row
        >
          <template v-slot:label>
            <div>Annually</div>
          </template>
          <v-radio :value="true">
            <template v-slot:label>
              <div>Yes</div>
            </template>
          </v-radio>

          <v-radio :value="false">
            <template v-slot:label>
              <div>No</div>
            </template>
          </v-radio>
        </v-radio-group>
      </div>

      <div class="d-flex flex-row justify-space-between">
        <v-select
          class="mr-2"
          v-model="ruleVaccination.minAgeYear"
          :items="ages"
          label="Start at age (year)"
          :rules="[v => v >= 0 || 'This field is required']"
        ></v-select>
        <v-select
          class="ml-2"
          v-model="ruleVaccination.minAgeMonth"
          :items="months"
          label="months"
          :rules="[v => v >= 0 || 'This field is required']"
        ></v-select>
      </div>

      <div v-if="!ruleVaccination.annually && ruleVaccination.multipleDose">
        <v-text-field
          :disabled="requirement.used" 
          @change="updateDoseSchdule"
          v-model.number="ruleVaccination.doseCount"
          label="Dose Count"
          placeholder="Enter a numeric number 1 or greater"
          type="number"
          inputmode="decimal"
          min="1"
          :rules="[rules.required]"
          :required="false"
        />

        <v-row v-for="(doseSchedule, index) in ruleVaccination.doseSchedules" :key="index" class="d-flex flex-column flex-md-row justify-space-between my-4">
          <v-col cols="12" md="4" class="my-auto">Time between dose {{index +1 }} and {{index +2}}:</v-col>
          <v-col class="d-flex flex-grow-1">
          <v-text-field
            :disabled="requirement.used" 
            v-model.number="doseSchedule.timeBetweenDose"
            type="number"
            inputmode="decimal"
            label="Time between doses"
            :rules="[rules.required]"
            :required="false"
            placeholder="Enter a numeric number 1 or greater"
            class="mx-2"
            outlined
            dense
            hide-details
          />

          <v-select
            :disabled="requirement.used" 
            v-model="doseSchedule.timeBetweenDoseUnit"
            :items="timeBetweenDoseUnits"
            :rules="[rules.required]"
            label="Time unit"
            class="mx-2"
            outlined
            dense
            hide-details
          ></v-select>
          </v-col>
        </v-row>
      </div>
      <v-divider class="my-5" />
      <div class="my-4 d-flex justify-space-between">
        <v-btn @click="goBack">
          Back
        </v-btn>
        <v-btn @click="handleSubmit" color="primary">
          {{ ruleVaccination.id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
    </v-form>
  </div>
</template>

<script>
import { getRuleVaccination } from "@/services/ruleVaccination";

import { getRequirement } from "@/services/requirement";

import { mapActions } from "vuex";
import Axios from "axios";

import { rules } from "@/store/util/rules.js";

export default {
  props: {
    value: {
      type: Object,
      required: false,
      default: null
    },
    requirementIds: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      loaded: false,
      valid: false,
      ages: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      timeBetweenDoseUnits: ["Days", "Months", "Years"],
      requirement: null,
      ruleVaccination: {
        id: null,
        multipleDose: true,
        annually: false,
        minAgeYear: 0,
        minAgeMonth: 0,
        doseCount: "",
        doseSchedules: [],
        requirementId: null
      },
      rules
    };
  },
  created() {
    if(this.value){
      this.id = this.value.id;
    }

    if (this.requirementIds && this.requirementIds.length > 0) {
      const requirementId = this.requirementIds[0];
      getRequirement(requirementId).then(resp => {
        this.requirement = resp.data;
        this.ruleVaccination.requirementId = this.value.requirementId;

        this.setInstance();
      });
    }
  },
  methods: {
    ...mapActions("ruleVaccination", [
      "createRuleVaccination",
      "updateRuleVaccination"
    ]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage"
    ]),

    async handleSubmit() {
      if (!this.$refs.form.validate()) {
        this.addErrorMessage("Please check your inputs");
        return;
      }

      if (this.id) {
        let ruleVaccination = this.ruleVaccination;
        this.prepDoseSchedulePostParams();
        this.updateRuleVaccination(ruleVaccination)
          .then(response => {
            console.log(response);
            this.addSuccessMessage("RuleVaccination was updated successfully");
            this.$router.push({name: 'requirementView', params: {id: this.requirement.id}})
          })
          .catch(() => {
            this.addErrorMessage(
              "Error updating RuleVaccination, please try again later"
            );
          });
      } else {
        const requests = [];
        for(const requirementId of this.requirementIds){
          let ruleVaccination = Object.assign({}, this.ruleVaccination);
          ruleVaccination.requirementId = requirementId;
          this.prepDoseSchedulePostParams();
          const createRequest = this.createRuleVaccination(ruleVaccination)
          requests.push(createRequest);
        }

        Axios.all(requests)
          .then(Axios.spread((...responses) => {
            this.addSuccessMessage("Vaccination rule was created successfully");

            if(responses.length == 1){
              this.$router.push({name: 'requirementView', params: { id: this.requirementIds[0] }})
            }
            else{ 
              this.$router.push({name: 'requirement'})
            }
          }))
          .catch(() => {
            this.addErrorMessage(
              "Error creating vaccination rule, please try again later"
            );
          });
      }
    },
    prepDoseSchedulePostParams(){
      const schedules = this.ruleVaccination.doseSchedules;
      const timeNextDose = {};
      const timeNextDoseUnit = {};
      schedules.forEach( (schedule, index) => {

        const key = `${index+1}`;
        timeNextDose[key] = schedule.timeBetweenDose;
        timeNextDoseUnit[key] = schedule.timeBetweenDoseUnit;
      })

      this.ruleVaccination.timeNextDose = timeNextDose;
      this.ruleVaccination.timeNextDoseUnit = timeNextDoseUnit;
    },
    goBack(){
      this.$emit('goBack', this.ruleVaccination);
    },
    setInstance() {
      if (this.id) {
        this.ruleVaccination.id = this.id;
        getRuleVaccination(this.id).then(response => {
          let instance = response.data;
          for (let property in instance) {
            if (
              Object.prototype.hasOwnProperty.call(instance, property) &&
              Object.prototype.hasOwnProperty.call(
                this.ruleVaccination,
                property
              )
            ) {
              this.ruleVaccination[property] = instance[property];
            }
          }

          let doseSchedules = this.ruleVaccination.doseSchedules;
          doseSchedules = doseSchedules.sort((a, b) => a.forDoseNumber > b.forDoseNumber ? 1 : -1);
          this.ruleVaccination.doseSchedules = doseSchedules.map( s => {
            return {
              timeBetweenDose: s.timeNextDose,
              timeBetweenDoseUnit: s.timeNextDoseUnit,
            }
          });

          this.loaded = true;
        });
      } else {
        this.loaded = true;
      }
    },
    updateDoseSchdule() {
      const count = this.ruleVaccination.doseCount;
      const currentCount = this.ruleVaccination.doseSchedules.length;
      if(count < currentCount){
        this.ruleVaccination.doseSchedules.splice(count-1, currentCount);
      }
      else if(count > currentCount){
        const newScheduleCount = count-currentCount-1;
        for(let i = 0; i< newScheduleCount; i++){
          this.ruleVaccination.doseSchedules.push({
            timeBetweenDose: 6,
            timeBetweenDoseUnit: 'Months',
          });
        }
      }
    }
  },
  components: {}
};
</script>
